import { letterList, letterTemplateContent} from "constants/letter";

const initialState = {
    letterList: {},
    letterTemplateContent: {},
};

const letters = (state = initialState, action) => {
    switch (action.type) {
        case letterList:
            return { ...state, letterList: action.payload };

        case letterTemplateContent:
            return { ...state, letterTemplateContent: action.payload };

        default:
            return state;
    }
};

export default letters;
